import { generate } from '@wcj/generate-password'
import { Copy } from 'component'
import { useEvent, useState } from 'hooks'
import { getPasswordGeneratorFormSelectors } from 'selectors'

type State = {
	passwordLabel?: HTMLElement
	passwordInputs?: NodeListOf<HTMLInputElement>
	generateButton?: HTMLElement
	minimalPasswordLength?: HTMLInputElement
}

export const PasswordManager = (() => {
	const { state, setState } = useState<State>()

	const handleGeneratePasswordClick = () => {
		const { passwordInputs, passwordLabel, minimalPasswordLength } = state
		if (!passwordInputs || !passwordLabel || !minimalPasswordLength) {
			return
		}
		const minLength = parseInt(minimalPasswordLength.value, 10)
		const randomLength = Math.floor(Math.random() * minLength) + minLength

		const newPassword = generate({
			length: randomLength,
			special: true,
			lowerCase: true,
			upperCase: true,
			numeric: true,
		})
		if (!newPassword) {
			return
		}

		for (let i = 0; i < passwordInputs.length; i++) {
			passwordInputs.item(i).value = newPassword
		}
		passwordLabel.innerHTML = newPassword
		passwordLabel.dataset.mCopy = 'password-preview-container'
		passwordLabel.dataset.mCopyValue = newPassword

		Copy.init()

		if (!passwordLabel.parentElement) {
			return
		}
		passwordLabel.parentElement.style.display = 'block'
	}

	const initPasswordManager = () => {
		const { generateButton } = state
		if (!generateButton) {
			return
		}
		const click = useEvent(generateButton, 'click')
		click.register(handleGeneratePasswordClick)
	}

	const init = () => {
		setState({
			...getPasswordGeneratorFormSelectors(),
		})
		initPasswordManager()
	}

	return {
		init,
	}
})()
